import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavbar } from "../../customHooks/Navbar/useNavbar";
import styles from "./NavBar.module.css";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";

import { FiLogOut, FiMenu } from "react-icons/fi";
import { HiUsers } from "react-icons/hi";
import { IoDiamondOutline } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { useMediaQuery } from "react-responsive";

const Navbar = () => {
  const hookProps = useNavbar();
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };
  const location = useLocation();
  const handleToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  const { handleLogout, tabs } = hookProps;

  return (
    <>
      {isDesktop ? (
        <>
          <Sidebar className={styles.leftsidebar} collapsed={isCollapsed}>
            <div className={styles.mainlogo}>
              <Link to={"/"}>
                {isCollapsed ? (
                  <img
                    src="/iAugment-icon.png"
                    alt="Logo"
                    className={styles.mainlogoicon}
                  />
                ) : (
                  <img src="/iAugment-logo-color.png" alt="Logo" />
                )}
              </Link>
            </div>

            <div className={styles.menuicon}>
              <FiMenu
                size={26}
                onClick={handleToggle}
                style={{ cursor: "pointer" }}
              />
            </div>

            <Menu>
              {tabs.map((item, index) => (
                <div key={index}>
                  {item.aChild ? (
                    <SubMenu
                      label={item.title}
                      icon={
                        item.title.includes("Model") ? (
                          <HiUsers />
                        ) : (
                          <IoDiamondOutline />
                        )
                      }
                      className={`${
                        location.pathname.includes(
                          item.title.replace(/\s+/g, "").toLowerCase()
                        )
                          ? "text-blue-600"
                          : ""
                      }`}
                    >
                      {item.aChild.map((child, childIndex) => (
                        <MenuItem
                          key={childIndex}
                          component={
                            <Link
                              to={`/${child.sModuleName
                                .replace(/\s+/g, "")
                                .toLowerCase()}`}
                            />
                          }
                          className={`${
                            location.pathname.includes(
                              child.sModuleName
                                .replace(/\s+/g, "")
                                .toLowerCase()
                            )
                              ? "text-blue-600"
                              : ""
                          }`}
                        >
                          {child.sModuleName}
                        </MenuItem>
                      ))}
                    </SubMenu>
                  ) : (
                    <MenuItem
                      component={
                        <Link
                          to={`/${item.title
                            .replace(/\s+/g, "")
                            .toLowerCase()}`}
                        />
                      }
                      icon={
                        item.title.includes("Model") ? (
                          <HiUsers />
                        ) : (
                          <IoDiamondOutline />
                        )
                      }
                      className={`${
                        location.pathname.includes(
                          item.title.replace(/\s+/g, "").toLowerCase()
                        )
                          ? "text-blue-600"
                          : ""
                      }`}
                    >
                      {item.title}
                    </MenuItem>
                  )}
                </div>
              ))}
            </Menu>

            {/* Logout Button */}
            <div className={styles.logouticon}>
              <Menu>
                <MenuItem icon={<FiLogOut />} onClick={handleLogout}>
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </Sidebar>
        </>
      ) : (
        <>
          {/* Top Navbar */}
          <div>
            {/* Top Navbar */}
            <nav className={styles.topNavbar}>
              <div className={styles.logo}>
                <img
                  src="/iAugment-logo-color.png"
                  alt="Logo"
                  className={styles.mainLogo}
                />
              </div>
              <div className={styles.menuIcon}>
                {!isMenuOpen ? (
                  <FiMenu
                    size={26}
                    onClick={toggleMenu}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <IoClose
                    size={26}
                    onClick={toggleMenu}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </div>
            </nav>

            {/* Dropdown Menu */}
            {isMenuOpen && (
              <div className={styles.menuWrapper}>
                <ul className={styles.menuList}>
                  {tabs.map((item, index) => (
                    <li key={index} className={styles.menuItem}>
                      {item.aChild ? (
                        <details className={styles.subMenu}>
                          <summary className={styles.subMenuLabel}>
                            {item.title}
                          </summary>
                          <ul className={styles.subMenuList}>
                            {item.aChild.map((child, childIndex) => (
                              <li key={childIndex}>
                                <Link
                                  to={`/${child.sModuleName
                                    .replace(/\s+/g, "")
                                    .toLowerCase()}`}
                                  className={`${
                                    location.pathname.includes(
                                      child.sModuleName
                                        .replace(/\s+/g, "")
                                        .toLowerCase()
                                    )
                                      ? "text-blue-600"
                                      : ""
                                  }`}
                                  onClick={() => setIsMenuOpen(false)}
                                >
                                  {child.sModuleName.includes("Model") ? (
                                    <HiUsers />
                                  ) : (
                                    <IoDiamondOutline />
                                  )}
                                  {child.sModuleName}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </details>
                      ) : (
                        <Link
                          to={`/${item.title
                            .replace(/\s+/g, "")
                            .toLowerCase()}`}
                          className={`${
                            location.pathname.includes(
                              item.title.replace(/\s+/g, "").toLowerCase()
                            )
                              ? "text-blue-600"
                              : ""
                          }`}
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {item.title.includes("Model") ? (
                            <HiUsers />
                          ) : (
                            <IoDiamondOutline />
                          )}
                          {item.title}
                        </Link>
                      )}
                    </li>
                  ))}
                  {/* Logout Button */}
                  <li className={styles.menuItem}>
                    <button
                      onClick={handleLogout}
                      className={styles.logoutButton}
                    >
                      <FiLogOut /> Logout
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Navbar;
